import { render, staticRenderFns } from "./ProductsSeller.vue?vue&type=template&id=ba6bb29c&"
import script from "./ProductsSeller.vue?vue&type=script&lang=js&"
export * from "./ProductsSeller.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSeller.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports